// import React from "react"
import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { about_banner_image } from '../../../all_constant';


// import PickupDate from '../../../assets/images/pickup-date.png';
// import BookYourCar from '../../../assets/images/book-your-car.png';

//for redux and saga
import { connect } from 'react-redux';
import { getAboutBanner } from '../../../redux/actions'


const AboutBanner = (props) => {
  const { getAboutBannerAction, getAboutBannerList, loading, error, messages } = props

  console.log("check---", getAboutBannerList, loading, error, messages);

  React.useEffect(() => {
    // alert('calld')
    window.scrollTo(0, 0);
    fetchData();
  }, []);

  function fetchData() {
    getAboutBannerAction(1);
  }

  const Main_title_detail = getAboutBannerList[getAboutBannerList.length - 1];

  return (
    <>
    { getAboutBannerList.length > 0
      ?
    <section className="about-content-wrap ">
      
      
        <Container>
          {getAboutBannerList && getAboutBannerList.slice(0,getAboutBannerList.length-1).map((item) => (
            <><Row>
              <Col>
                <div className="row ">
                  <div className="col-lg-12 ">
                    <h2 className="main-title ">{item.MainTitle}</h2>
                  </div>
                </div>
                <div className="about-detail mt-4">
                  {/* <span className="about-title">About Us</span> */}
                  <p className="trip-text">
                    {/* We make your{" "} */}
                    {/* <span className="highlighted-text-color">car rental </span> */}
                    <span className="highlighted-text">
                      {item.SubTitle} 
                    </span>
                  </p>
                </div>
              </Col>
            </Row><Row>
                <Col>
                  <div className="about-us-img">
                    <img src={`${about_banner_image}/${item.BannerImage}`} alt="about-us-image" className="w-100" />
                  </div>
                </Col>
              </Row></>
          ))}
        <div className="about-more">
            <Row>
              <Col>
                <div>
                  <h1>
                  {Main_title_detail.MainTitle}
                  </h1>
                </div>
              </Col>
              <Col>
                <div className="right-about-more">
                  {" "}
                  <p>
                    {Main_title_detail.SubTitle}
                  </p>
                </div>
              </Col>
            </Row>
          </div></Container>
    </section>
    :<section> </section>
         
      }
      </>
  );

}

//   export default HowitWork;
const mapStateToProps = ({ aboutbanner }) => { 
  // console.log('======', howitwork);
  const { loading, error, messages, getAboutBannerList } = aboutbanner;
  return { loading, error, messages, getAboutBannerList };
};

export default connect(mapStateToProps, {
  getAboutBannerAction: getAboutBanner,
})(AboutBanner);


